import { Rules } from 'constants/Permissions';
import { SubscriptionTiers } from 'constants/AdminConstants';
export var isAllowed = function (subscriptionTier, subscriptionPaused, role, permission) {
    var _a;
    console.log('isAllowed', subscriptionTier, subscriptionPaused, role, permission);
    if (!Rules[permission]) {
        return false;
    }
    var subscriptionTierAdjusted = subscriptionPaused ?
        SubscriptionTiers.FREE :
        subscriptionTier;
    if (!((_a = Rules[permission][subscriptionTierAdjusted]) === null || _a === void 0 ? void 0 : _a[role])) {
        return false;
    }
    return true;
};
export var isAllowedHelper = function (companyStore, permission) {
    var companyInfo = companyStore.getCompanyInfo();
    var account = companyInfo.account, currentUser = companyInfo.current_user;
    var subscriptionTier = account.stripe_product_tier, subscriptionProductIsPaused = account.stripe_product_is_paused, subscriptionStatus = account.stripe_status;
    var subscriptionPaused = subscriptionProductIsPaused ||
        subscriptionStatus === 'paused';
    var role = currentUser.role_id;
    return isAllowed(subscriptionTier, subscriptionPaused, role, permission);
};
export default {
    isAllowed: isAllowed
};
